import React from "react";
import { GisMapWrapper } from "@gis/GisMapWrapper";
import MapClickCoordinates from "@gis/components/MapClickedCoordinates";
import GenericMarker from "@gis/components/GenericMarker";
import NocMarkerBlue from "@gis/assets/images/logo/noc-yellow-marker.svg";
import NocMarkerGreen from "@gis/assets/images/logo/noc-green-marker.svg";
import CurrentLocation from "@gis/assets/images/logo/current_location.svg";
import { useSelector } from "react-redux";
import StretchDisplay from "@gis/components/StretchDisplay";
import LocationMarker from "@gis/components/LocationMarker";
import { startLocationElement, endLocationElement } from "@gis/components/overlayElements";

interface MapPanelProps {
  // selectedStretch: any;
  hideRemovePin: boolean;
  endChainage: string;
  startChainage: string;
  geoCoordinates: any;
  isFirstSectionCompletedRow: boolean;
  start_coordinates: {
    longitude: string | number;
    latitude: string | number;
  };
  end_coordinates: {
    longitude: string | number;
    latitude: string | number;
  };
  onMapClick: (
    coords: { latitude: number; longitude: number },
    chainage: any
  ) => void;
}

const DEFAULT_CENTER: [number, number] = [77.31344843909721, 28.567578971251322];

function getMapCenter(
  start_coordinates: { longitude: string | number; latitude: string | number },
  end_coordinates: { longitude: string | number; latitude: string | number },
  geoCoordinates: { longitude: string | number; latitude: string | number }
): [number, number] {
  const startLat = Number(start_coordinates?.latitude) || 0;
  const startLng = Number(start_coordinates?.longitude) || 0;
  const endLat = Number(end_coordinates?.latitude) || 0;
  const endLng = Number(end_coordinates?.longitude) || 0;
  const geoLat = Number(geoCoordinates?.latitude) || 0;
  const geoLng = Number(geoCoordinates?.longitude) || 0;

  if (startLat !== 0 && startLng !== 0) return [startLng, startLat];
  if (endLat !== 0 && endLng !== 0) return [endLng, endLat];
  if (geoLat !== 0 && geoLng !== 0) return [geoLng, geoLat];
  return DEFAULT_CENTER;
}

const MapPanel = React.memo(
  ({ hideRemovePin, startChainage, endChainage, geoCoordinates, start_coordinates, end_coordinates, onMapClick, isFirstSectionCompletedRow }: MapPanelProps & { isFirstSectionCompletedRow: boolean }) => {
    const { searchCoordinates, selectedStretch } = useSelector((state: any) => state.gisData);
    const [zoomLevel, setZoomLevel] = React.useState<number>(9);

    React.useEffect(() => {
      if (searchCoordinates.longitude !== 0 || center[0] !== 0) {
        setZoomLevel(15);
      } else {
        setZoomLevel(9);
      }
    }, [start_coordinates, geoCoordinates]);

    const center = getMapCenter(start_coordinates, end_coordinates, geoCoordinates);

    return ((
      <div style={{ width: "100%", height: "500px", pointerEvents: !isFirstSectionCompletedRow ? "none" : "auto", opacity: !isFirstSectionCompletedRow ? 0.5 : 1 }}>
        <GisMapWrapper center={searchCoordinates.latitude === 0 ? center : [searchCoordinates.longitude, searchCoordinates.latitude]} zoom={zoomLevel}>
          <MapClickCoordinates onClick={onMapClick} />
          <StretchDisplay multiLineCoordinates={selectedStretch?.[0]?.multi_lines?.coordinates} color="#19d031ff" width={3} />
          {(geoCoordinates?.longitude !== 0 && geoCoordinates?.latitude !== 0) && (
            <GenericMarker
              coordinates={[
                Number(geoCoordinates?.longitude) || 0,
                Number(geoCoordinates?.latitude) || 0,
              ]}
              size={0.5}
              anchor={[0.5, 1]}
              img={CurrentLocation}
            />
          )}
          {start_coordinates?.longitude !== 0 && (
            <>
              <GenericMarker
                coordinates={[
                  Number(start_coordinates?.longitude) || 0,
                  Number(start_coordinates?.latitude) || 0,
                ]}
                size={0.5}
                anchor={[0.5, 1]}
                img={NocMarkerGreen}
              />

              <LocationMarker
                coordinates={[
                  Number(start_coordinates?.longitude) || 0,
                  Number(start_coordinates?.latitude) || 0,
                ]}
                html={
                  startLocationElement(start_coordinates?.latitude.toString() || '0',
                    start_coordinates?.longitude.toString() || '0',
                    startChainage,
                    hideRemovePin,
                    'startLocation')}
              />

            </>
          )}
          {start_coordinates?.longitude !== 0 && (
            <>
              <GenericMarker
                coordinates={[
                  Number(end_coordinates?.longitude) || 0,
                  Number(end_coordinates?.latitude) || 0,
                ]}
                size={0.5}
                anchor={[0.5, 1]}
                img={NocMarkerBlue}
              />

              <LocationMarker
                coordinates={[
                  Number(end_coordinates?.longitude) || 0,
                  Number(end_coordinates?.latitude) || 0,
                ]}
                html={
                  endLocationElement(end_coordinates?.latitude.toString() || '0',
                    end_coordinates?.longitude.toString() || '0',
                    endChainage,
                    hideRemovePin,
                    'startLocation')}
              />
            </>
          )}
        </GisMapWrapper>
      </div>
    ))
  }
);

export default MapPanel;
